import React, { useMemo } from 'react';
import { Route, useLocation } from 'react-router-dom';
import { notifyTrackingEvent } from '../../store/to-native';
import capitalize from 'lodash.capitalize';
import { useEffect } from 'react';
import { IRoute } from '../../views/routes';

const handleHome = pathname => {
  if (pathname === '/') {
    return 'Home';
  }
};
const handleCategories = pathname => {
  if (pathname.includes('cat')) {
    return pathname
      .split('/')
      .slice(1)
      .join(' / ');
  }
};
const handleCapitalization = pathname =>
  pathname
    .split(/([^A-Za-z])/)
    .map(capitalize)
    .join('');

const handleDashes = pathname => pathname.replace('-', '');

const getPageString = pathname => {
  return [
    decodeURIComponent,
    p => p.slice(1),
    handleHome,
    handleCategories,
    handleCapitalization,
    handleDashes,
  ].reduce((acc, transform) => transform(acc) || acc, pathname);
};

const TrackedRoute: React.FC<IRoute> = props => {
  const { pathname } = useLocation();
  const page = useMemo(() => getPageString(pathname), [pathname]);
  useEffect(() => {
    notifyTrackingEvent('LoadedALibraryPage', { page });
  }, [page]);

  return <Route {...props} />;
};

export default TrackedRoute;
